import React from 'react'
import Link from 'next/link'
import { CaretLeftIcon } from '@/atoms/Icons/CaretLeftIcon'
import { ParagraphMD } from '@/atoms/Text'
import { paths } from '@/constants'

interface Props {
  className?: string
  children: React.ReactNode
}

export const BackButton: React.FC<Props> = ({ children, className }) => {
  return (
    <Link href={paths.torches.index} className={className}>
      <ParagraphMD color="white" className="flex items-center">
        <CaretLeftIcon className="h-4" />
        {children}
      </ParagraphMD>
    </Link>
  )
}
